var _path, _circle;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgOpenedEyeIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 3.75C10.1002 3.75 11.9653 4.24814 13.2793 5.01465C14.6116 5.79187 15.25 6.75588 15.25 7.66699C15.2498 8.57798 14.6113 9.54124 13.2793 10.3184C11.9653 11.0849 10.1002 11.583 8 11.583C5.89978 11.583 4.03472 11.0849 2.7207 10.3184C1.3887 9.54124 0.750152 8.57798 0.75 7.66699C0.75 6.75588 1.38844 5.79187 2.7207 5.01465C4.03472 4.24814 5.89978 3.75 8 3.75Z",
    stroke: "#6C6859",
    strokeWidth: 1.5
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 8.00008,
    cy: 7.66658,
    r: 2.28573,
    stroke: "#6C6859",
    strokeWidth: 1.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOpenedEyeIcon);
export default __webpack_public_path__ + "static/media/OpenedEyeIcon.bafa57fbc293a1c0191b2e9da9122a38.svg";
export { ForwardRef as ReactComponent };